module.exports = __webpack_public_path__ + "img/img1.cac7fa46.png";